import { h } from "hyperapp";

import inlineLoadingCSS from "./inline-loading.css";

export const inlineLoading = () => <div class={inlineLoadingCSS.spinner} />;
